import { render, staticRenderFns } from "./devMain.vue?vue&type=template&id=08b29fd9&scoped=true&"
import script from "./devMain.vue?vue&type=script&lang=js&"
export * from "./devMain.vue?vue&type=script&lang=js&"
import style0 from "./devMain.vue?vue&type=style&index=0&id=08b29fd9&scoped=true&lang=css&"
import style1 from "./devMain.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b29fd9",
  null
  
)

export default component.exports